import React from 'react';
import ErrorReporter from 'app/components/ErrorReporter';
import { ApolloError } from 'apollo-client';

export default function renderErrorReporter(error: ApolloError | string) {
  return (
    <ErrorReporter error={error}>
      There was a problem loading this page. Please try again and contact coaching@remind.com if the
      problem persists.
    </ErrorReporter>
  );
}
